const EmptyTable = ({ columnLength }: { columnLength: number }) => {
  return (
    <tr key={0}>
      {new Array(columnLength).fill('').map((entry, index) => {
        return <td key={index}>--</td>;
      })}
    </tr>
  );
};

export default EmptyTable;
